import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Store scroll positions and visited pages outside component to persist across renders
const scrollPositions = new Map<string, number>();
const visitedPages = new Set<string>();

export const useScrollRestoration = () => {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Save scroll position of previous page
    if (prevPathRef.current && prevPathRef.current !== currentPath) {
      scrollPositions.set(prevPathRef.current, window.scrollY);
    }

    // Check if first visit
    const isFirstVisit = !visitedPages.has(currentPath);
    
    if (isFirstVisit) {
      // First visit - scroll to top
      window.scrollTo(0, 0);
      visitedPages.add(currentPath);
    } else {
      // Returning visit - restore position
      const savedPosition = scrollPositions.get(currentPath) || 0;
      window.scrollTo(0, savedPosition);
    }

    prevPathRef.current = currentPath;
  }, [location.pathname]);

  // Save scroll position on every scroll
  useEffect(() => {
    const currentPath = location.pathname;
    
    const handleScroll = () => {
      scrollPositions.set(currentPath, window.scrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);
};
